(function () {
  var SECTION_SELECTOR = '.oddit-section-video-reviews';
  var PREVIEW_SECONDS = 3;
  var sectionState = new Map();

  function initSection(section) {
    var track = section.querySelector('.oddit-section-video-reviews__track');
    var dots = Array.prototype.slice.call(section.querySelectorAll('.oddit-section-video-reviews__dot'));
    var cards = Array.prototype.slice.call(track.querySelectorAll('.oddit-section-video-reviews__card'));
    if (!track || cards.length === 0) return;

    var scrollRaf = null;

    function pageCount() {
      return Math.min(dots.length, Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth)));
    }

    function activePage() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return 0;
      return Math.round((track.scrollLeft / maxScroll) * (pageCount() - 1));
    }

    function updateDots() {
      var pages = pageCount();
      var active = activePage();
      for (var i = 0; i < dots.length; i++) {
        var isActive = i === active;
        dots[i].hidden = i >= pages;
        dots[i].classList.toggle('oddit-section-video-reviews__dot--active', isActive);
        dots[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    }

    function scrollToPage(index) {
      var pages = pageCount();
      var maxScroll = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: pages > 1 ? (index / (pages - 1)) * maxScroll : 0, behavior: 'smooth' });
    }

    track.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        updateDots();
      });
    }, { passive: true });

    for (var i = 0; i < dots.length; i++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          scrollToPage(idx);
        });
      })(i);
    }

    /* ── Shopify-hosted video ──
       Blocks with a `video_file` render a <video preload="none"> under the play
       button. Clicking it starts playback. */
    track.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-video-play]') : null;
      if (!btn) return;
      var video = btn.parentElement.querySelector('.oddit-section-video-reviews__video');
      if (!video) return;
      // Hand off from a running hover preview: sound on, back to the start.
      delete video.dataset.preview;
      video.muted = false;
      video.currentTime = 0;
      btn.parentElement.classList.add('is-playing');
      video.play();
    });

    // play/ended do not bubble — listen in the capture phase.
    track.addEventListener('play', function (e) {
      var video = e.target;
      if (!video.classList || !video.classList.contains('oddit-section-video-reviews__video')) return;
      if (video.dataset.preview) return;
      video.parentElement.classList.add('is-playing');
      // One video at a time.
      track.querySelectorAll('.oddit-section-video-reviews__video').forEach(function (other) {
        if (other !== video) other.pause();
      });
    }, true);

    /* ── Hover preview: first 3 seconds, muted, looping ── */
    if (window.matchMedia('(hover: hover)').matches) {
      cards.forEach(function (card) {
        var video = card.querySelector('.oddit-section-video-reviews__video');
        if (!video) return;

        video.addEventListener('timeupdate', function () {
          if (video.dataset.preview && video.currentTime >= PREVIEW_SECONDS) video.currentTime = 0;
        });

        // The source is a single 1080p file behind preload="metadata", so the
        // first hover has nothing buffered and that first play() often aborts.
        // Retry once data lands, as long as the pointer is still on the card.
        video.addEventListener('canplay', function () {
          if (video.dataset.preview && video.paused) video.play().catch(function () {});
        });

        card.addEventListener('mouseenter', function () {
          if (video.parentElement.classList.contains('is-playing')) return;
          video.dataset.preview = 'true';
          video.muted = true;
          var started = video.play();
          // Autoplay can still be refused (e.g. Low Power Mode) — poster stays.
          if (started && started.catch) started.catch(function () {});
        });

        card.addEventListener('mouseleave', function () {
          if (!video.dataset.preview) return;
          delete video.dataset.preview;
          video.pause();
          video.currentTime = 0;
          video.muted = false;
        });
      });
    }

    track.addEventListener('ended', function (e) {
      var video = e.target;
      if (!video.classList || !video.classList.contains('oddit-section-video-reviews__video')) return;
      video.parentElement.classList.remove('is-playing');
      delete video.dataset.preview;
      // Only load() puts the poster back — seeking to 0 leaves the first frame.
      video.load();
    }, true);

    // Mouse drag only — touch keeps native scroll-snap.
    var dragActive = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragLastX = 0;

    function settleToNearestCard() {
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      var trackLeft = track.getBoundingClientRect().left;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var delta = cards[i].getBoundingClientRect().left - trackLeft - pad;
        if (Math.abs(delta) < bestDist) {
          bestDist = Math.abs(delta);
          best = delta;
        }
      }
      track.scrollTo({ left: track.scrollLeft + best, behavior: 'smooth' });
    }

    function onPointerDown(e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      dragActive = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragLastX = e.clientX;
      track.classList.add('is-dragging');
    }

    function onPointerMove(e) {
      if (!dragActive) return;
      var dx = e.clientX - dragLastX;
      dragLastX = e.clientX;
      if (Math.abs(e.clientX - dragStartX) > 4) dragMoved = true;
      track.scrollLeft -= dx;
    }

    function endDrag() {
      if (!dragActive) return;
      dragActive = false;
      track.classList.remove('is-dragging');
      if (dragMoved) settleToNearestCard();
    }

    function onClickCapture(e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }

    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('click', onClickCapture, true);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    window.addEventListener('resize', updateDots);
    updateDots();

    section._odditTeardown = function () {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', endDrag);
      window.removeEventListener('pointercancel', endDrag);
      window.removeEventListener('resize', updateDots);
    };
    sectionState.set(section, true);
  }

  function destroySection(section) {
    if (section._odditTeardown) section._odditTeardown();
    sectionState.delete(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
